import { Box, Grid, Typography, makeStyles } from "components/Mui";

const useStyles = makeStyles(() => {
  return {
    wrapper: {
      position: "relative",
      width: "100%",
      height: "100%",
      padding: "20px",
      background: "linear-gradient(137.79deg, #7584D7 2.02%, #443D99 98.56%)",
      borderRadius: "12px",
    },
  };
});

function CanisterIcon() {
  return (
    <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.24661 4.0788C1.6771 4.54489 1.5 4.94486 1.5 5.25C1.5 5.55514 1.6771 5.95511 2.24661 6.4212C2.81058 6.88275 3.6721 7.33179 4.80294 7.72324C7.0575 8.50366 10.2208 9 13.75 9C17.2792 9 20.4425 8.50366 22.6971 7.72324C23.8279 7.33179 24.6894 6.88275 25.2534 6.4212C25.8229 5.95511 26 5.55514 26 5.25C26 4.94486 25.8229 4.54489 25.2534 4.0788C24.6894 3.61725 23.8279 3.16821 22.6971 2.77676C20.4425 1.99634 17.2792 1.5 13.75 1.5C10.2208 1.5 7.0575 1.99634 4.80294 2.77676C3.6721 3.16821 2.81058 3.61725 2.24661 4.0788ZM4.31228 1.35928C6.7628 0.511024 10.0995 0 13.75 0C17.4005 0 20.7372 0.511024 23.1877 1.35928C24.4094 1.78217 25.4517 2.3028 26.2034 2.91799C26.9496 3.52865 27.5 4.3125 27.5 5.25C27.5 6.1875 26.9496 6.97135 26.2034 7.58201C25.4517 8.1972 24.4094 8.71783 23.1877 9.14072C20.7372 9.98898 17.4005 10.5 13.75 10.5C10.0995 10.5 6.7628 9.98898 4.31228 9.14072C3.09059 8.71783 2.0483 8.1972 1.2966 7.58201C0.550434 6.97135 0 6.1875 0 5.25C0 4.3125 0.550434 3.52865 1.2966 2.91799C2.0483 2.3028 3.09059 1.78217 4.31228 1.35928Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.82685 20.5855C7.07355 21.4496 10.2281 22 13.75 22C17.2719 22 20.4264 21.4496 22.6732 20.5855C23.799 20.1525 24.6587 19.6553 25.2238 19.1413C25.7888 18.6276 26 18.1563 26 17.75H27.5C27.5 18.7244 26.9837 19.5685 26.233 20.2511C25.4825 20.9336 24.4383 21.5137 23.2116 21.9855C20.7533 22.9311 17.4078 23.5 13.75 23.5C10.0922 23.5 6.74675 22.9311 4.28838 21.9855C3.06169 21.5137 2.01753 20.9336 1.26703 20.2511C0.516306 19.5685 0 18.7244 0 17.75H1.5C1.5 18.1563 1.71123 18.6276 2.27618 19.1413C2.84135 19.6553 3.70099 20.1525 4.82685 20.5855Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 4.75V17.75H0V4.75H1.5ZM26 17.75V4.75H27.5V17.75H26Z"
        fill="white"
      />
      <path
        d="M17.0164 12.75C16.3325 12.75 15.5865 13.1145 14.799 13.8331C14.426 14.1716 14.0996 14.5361 13.8613 14.8277C13.8613 14.8277 14.2447 15.2599 14.6643 15.7233C14.8923 15.4421 15.2186 15.062 15.5968 14.7183C16.2962 14.0778 16.7521 13.9477 17.0164 13.9477C18.0006 13.9477 18.7985 14.7548 18.7985 15.7545C18.7985 16.7439 18.0006 17.551 17.0164 17.5614C16.9697 17.5614 16.9127 17.5562 16.8454 17.5406C17.1303 17.6708 17.4411 17.7645 17.7312 17.7645C19.5341 17.7645 19.8863 16.546 19.907 16.4575C19.9588 16.2336 19.99 15.9993 19.99 15.7598C19.9848 14.0987 18.6534 12.75 17.0164 12.75Z"
        fill="url(#paint0_linear_21175_75502)"
      />
      <path
        d="M10.7237 18.745C11.4075 18.745 12.1535 18.3805 12.941 17.6619C13.314 17.3234 13.6403 16.9589 13.8786 16.6673C13.8786 16.6673 13.4953 16.2351 13.0757 15.7717C12.8477 16.0529 12.5213 16.433 12.1431 16.7767C11.4438 17.412 10.9827 17.5473 10.7237 17.5473C9.73935 17.5473 8.94153 16.7402 8.94153 15.7404C8.94153 14.7511 9.73935 13.944 10.7237 13.9336C10.7703 13.9336 10.8273 13.9388 10.8946 13.9544C10.6097 13.8242 10.2989 13.7305 10.0087 13.7305C8.20589 13.7305 7.8536 14.949 7.83289 15.0375C7.78109 15.2614 7.75 15.4957 7.75 15.7352C7.75 17.3963 9.08141 18.745 10.7237 18.745Z"
        fill="url(#paint1_linear_21175_75502)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0931 14.7444C11.8963 14.5569 10.9327 13.7914 10.0105 13.7654C8.36719 13.725 7.88411 14.8949 7.84246 15.0458C8.15723 13.7339 9.33057 12.7552 10.7254 12.75C11.8626 12.75 13.0117 13.8419 13.8608 14.8273C13.8621 14.8256 13.8635 14.824 13.8648 14.8224C13.8648 14.8224 14.2481 15.2546 14.6678 15.7181C14.6678 15.7181 15.1444 16.27 15.6521 16.7543C15.8489 16.9418 16.8073 17.6968 17.7295 17.7228C19.4184 17.7697 19.8847 16.5356 19.9105 16.4419C19.5998 17.7593 18.4237 18.7434 17.0249 18.7487C15.8874 18.7487 14.7379 17.6561 13.8853 16.6704C13.8836 16.6724 13.882 16.6744 13.8804 16.6762C13.8804 16.6762 13.4971 16.244 13.0774 15.7806C13.0774 15.7806 12.6008 15.2286 12.0931 14.7444ZM7.83984 15.0568C7.84031 15.0541 7.84117 15.0504 7.84246 15.0458C7.84158 15.0494 7.84071 15.0531 7.83984 15.0568Z"
        fill="#29ABE2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_21175_75502"
          x1="15.4567"
          y1="13.1848"
          x2="19.5718"
          y2="17.4243"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#F15A24" />
          <stop offset="0.6841" stopColor="#FBB03B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_21175_75502"
          x1="12.2799"
          y1="18.308"
          x2="8.16484"
          y2="14.0684"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#ED1E79" />
          <stop offset="0.8929" stopColor="#522785" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default function FileImage({ fileType }: { fileType: string }) {
  const classes = useStyles();

  return (
    <Grid container alignItems="center" justifyContent="center" className={classes.wrapper}>
      <Box
        sx={{
          position: "absolute",
          top: "20px",
          left: "20px",
        }}
      >
        <CanisterIcon />
      </Box>
      <Typography color="text.primary" fontSize="28px" fontWeight={500}>
        .{fileType}
      </Typography>
    </Grid>
  );
}
